import { EventAttendee, EventAttendeeRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createEventAttendee: (
  fetchContext: FetchContext,
  questionnaireId: number,
  eventAttendee: EventAttendee,
  accessToken?: string,
) => Promise<EventAttendeeRef> = async (fetchContext, questionnaireId, eventAttendee, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/event-attendees`, {
    method: 'POST',
    body: JSON.stringify(eventAttendee),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<EventAttendeeRef>(fetchContext.errorStore, response, 'create event attendee'));
};
